var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"is-edit-name":!_vm.data.is_system,"is-edit-desc":!_vm.data.is_system,"nameRules":_vm.nameRules}})
}
var staticRenderFns = []

export { render, staticRenderFns }